import { application } from "./application";
import BoardCanvasController from "./board_canvas_controller";
import MatchSelectorController from "./match_selector_controller";
import ModalController from "./modal_controller";

application.register("modal", ModalController);
application.register("board-canvas", BoardCanvasController);
application.register("match-selector", MatchSelectorController);
